import { strings } from '../localisation';
///
/// Used to get initials from name.
/// This should be removed and replaced by Initials property from server.
///
export function getInitialsFromName(name: string) {
    const result = name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);
    return result ? result.join('') : name;
}

export const getResultCountMessage = (count: number): string => {
    if (count === 0) {
        return strings.Search_Label_NoResultsFound;
    } else if (count === 1) {
        return strings.Search_Label_OneResultFound;
    } else {
        return count + strings.Search_Label_MoreResultsFound;
    }
};

/**
 * Replaces the last occurrence of a string.
 * @param inString The string to test
 * @param find What to find
 * @param replace Replace the found item with.
 */
export function replaceLastOccurrence(inString: string, find: string, replace: string) {
    const index = inString.lastIndexOf(find);
    if (index >= 0) {
        return inString.substring(0, index) + inString.substring(index).replace(find, replace);
    }
    return inString.toString();
}

export const randomID = () => Math.random().toString(36).substr(2, 10);
